import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPageTab } from '../../interfaces';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-vesta-tabs',
    templateUrl: './vesta-tabs.component.html',
    styleUrls: ['./vesta-tabs.component.scss']
})
export class VestaTabsComponent implements OnInit {
    @Input() tabs: IPageTab[] = [];
    @Output() segmentChanged: EventEmitter<string> = new EventEmitter<string>();

    public segment: string = '';
    private queryParamsSubscription: Subscription | undefined;

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.queryParamsSubscription = this.route.queryParams.subscribe((params: Params) => {
            this.segment = params['segment'] || this.tabs[0].segment;

            const tab: IPageTab = this.tabs.find((t: IPageTab) => t.segment === this.segment) as IPageTab;

            if (!tab || (tab && tab.disabled)) {
                this.segment = this.tabs[0].segment as string;
                this.navigate(this.tabs[0]);
            }

            this.segmentChanged.emit(this.segment);
        });
    }

    ngOnDestroy() {
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
    }

    navigate(tab: IPageTab) {
        void this.router.navigate([tab.route], {
            queryParamsHandling: 'merge',
            queryParams: {
                segment: tab.segment
            }
        });
    }
}
